import React, {
  createContext,
  useContext,
  FunctionComponent,
  useState,
  PropsWithChildren,
} from "react";

import {Admission} from "@reside/reside-api-admission";
import {AdmissionFromSearch} from "../../../services/AdmissionsService";

const context = createContext({
  admission: undefined,
  toggle: (admission?: Admission | AdmissionFromSearch) => {},
  forceDeleteAdmission: undefined,
  toggleForceDeleteModal: (admission?: Admission | AdmissionFromSearch) => {},
});

export const useAdmissionsDeleteModalContext = () => useContext(context);

export const AdmissionsDeleteModalProvider: FunctionComponent<
  PropsWithChildren<{}>
> = ({children}) => {
  const [admission, setAdmission] = useState<Admission | AdmissionFromSearch>(
    undefined,
  );
  const [forceDeleteAdmission, setForceDeleteAdmission] = useState<
    Admission | AdmissionFromSearch
  >(undefined);

  const toggleForceDeleteModal = (
    admission?: Admission | AdmissionFromSearch,
  ) => {
    setForceDeleteAdmission(admission);
  };

  return (
    <context.Provider
      value={{
        admission,
        toggle: setAdmission,
        forceDeleteAdmission,
        toggleForceDeleteModal,
      }}
    >
      {children}
    </context.Provider>
  );
};
